import { sortAccountsByCategoryAndBalance } from '@/utils/accounts/sort-accounts-by-category-and-balance';
import { UTCDate } from '@/utils/dates';
import { DataEntities } from './data-provider';

export const getSortedData = (data: DataEntities) => {
  const { accounts, cards, transactions, categories, payrolls } = data;

  // Sort accounts by category (Modulr, Treasury, Open Banking) and then by balance (descending)
  // Order: Modulr Account (Seapoint) -> Treasury Account (Seapoint) -> Open Banking Accounts
  // Within each category, accounts are sorted by balance in descending order
  sortAccountsByCategoryAndBalance(accounts);

  // All transaction views in the app should be sorted by date by default
  transactions.sort((a, b) => new UTCDate(b.fspDate || '').getTime() - new UTCDate(a.fspDate || '').getTime());

  // Categories are sorted based in the `order` field determined by the backend
  categories.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  // Sort payrolls by creation date in descending order (newest first)
  payrolls.sort((a, b) => new UTCDate(b.createdAt).getTime() - new UTCDate(a.createdAt).getTime());

  // Sort cards by creation date in descending order (newest first)
  cards.sort((a, b) => new UTCDate(b.createdAt).getTime() - new UTCDate(a.createdAt).getTime());

  return data;
};
